import { render, staticRenderFns } from "./firstRecord.vue?vue&type=template&id=124302bc&scoped=true"
import script from "./firstRecord.vue?vue&type=script&lang=js"
export * from "./firstRecord.vue?vue&type=script&lang=js"
import style0 from "./firstRecord.vue?vue&type=style&index=0&id=124302bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124302bc",
  null
  
)

export default component.exports